const steps = [
  {
    number: "01",
    icon: "ri-file-list-3-line",
    title: "Apply",
    desc: "Complete our straightforward application form. Tell us about your background, your goals, and what you hope to achieve through the academy. No prior experience required.",
    detail: "Takes less than 10 minutes",
  },
  {
    number: "02",
    icon: "ri-user-received-line",
    title: "Get Enrolled",
    desc: "Our team will review your application and reach out to discuss the right learning pathway for you. We will guide you through enrollment and help you prepare for your first session.",
    detail: "Personalized onboarding",
  },
  {
    number: "03",
    icon: "ri-graduation-cap-line",
    title: "Begin Learning",
    desc: "Start your structured learning journey through classes, simulations, webinars, and guided training. Build knowledge progressively with the support of instructors and a community of peers.",
    detail: "Structured & supported",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            <span className="w-8 h-px bg-[#C9A961]" />
            The Process
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] mb-4">
            How It Works
          </h2>
          <p className="text-[#6B6B6B] text-base max-w-xl mx-auto font-light leading-relaxed">
            Getting started is simple. Three clear steps stand between you and a structured financial education designed for your future.
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-16 left-[calc(16.67%+2rem)] right-[calc(16.67%+2rem)] h-px bg-[#E8E4DC]" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {steps.map((step, i) => (
              <div key={step.number} className="relative flex flex-col items-center text-center group">
                {/* Step circle */}
                <div className="relative z-10 w-16 h-16 flex items-center justify-center rounded-full bg-[#1A4D3C] mb-6 group-hover:bg-[#C9A961] transition-colors duration-300">
                  <i className={`${step.icon} text-white text-2xl`} />
                  <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-[#C9A961] group-hover:bg-[#1A4D3C] transition-colors duration-300">
                    <span className="text-[10px] font-bold text-white">{i + 1}</span>
                  </div>
                </div>

                <div className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#2B2D2F] mb-2">{step.title}</div>
                <p className="text-[#6B6B6B] text-sm leading-relaxed mb-4 max-w-xs">{step.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-[#C9A961]">
                  <i className="ri-checkbox-circle-line text-sm" />
                  {step.detail}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <a
            href="#apply"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#1A4D3C] text-white font-semibold text-sm hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Your Application
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
